module.exports = __webpack_public_path__ + "static/avantages_hospital_responsive-8a2ec899b471d2b307b84866011cd6ae.svg";